import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../../components/header/header';
import Strings from '../../../i18n';
import { ContainerStyled, TooltipStyled } from '../../locations/locationStyles';
import { ButtonIconStyled, TitleStyled } from '../../devices/devicesStyles';
import { useGetShippingOrderMutation } from '../../../services/manufacture/manufactureService';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { CreateSerialNumberSideBar } from '../../../templates/manufacture/serialNumberTemplate/createSerialNumberSideBar/createSerialNumberSideBar';
import { ShipipngOrderTemplate } from '../../../templates/manufacture/shippingOrderTemplate/shippingOrderTemplate';
import { EditShippingOrderSideBar } from '../../../templates/manufacture/shippingOrderTemplate/editShippingOrderSideBar/editShippingOrderSideBar';

export const ManufacturingShipingOrderView = () => {
  const navigate = useNavigate();
  const [openSideBarFor, setOpenSideBarFor] = useState<number | null>(null);
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  const [getShippingOrder, { isSuccess, data, isLoading }] =
    useGetShippingOrderMutation();

  const reloadTable = () => {
    getShippingOrder(null);
    setSelectedItems([]);
    return {};
  };

  useEffect(() => {
    reloadTable();
  }, []);

  const redirectToAddShippingOrder = () => {
    navigate('/Manufacturing/shippingOrder/add');
  };

  const handleRightSideBarMethod = (method: number) => {
    setOpenSideBarFor(method);
  };

  const switchComponentToShowRightSideBar = () => {
    switch (openSideBarFor) {
      case viewRightSideBarEnum.createPartNumber:
        return (
          <CreateSerialNumberSideBar
            reloadTable={reloadTable}
            setOpenSideBar={setOpenSideBar}
            openRightSideBarForMethod={handleRightSideBarMethod}
          />
        );
      case viewRightSideBarEnum.singleShippingOrder:
        return (
          <EditShippingOrderSideBar
            shippingOrder={selectedItems[0]}
            reloadTable={reloadTable}
            setOpenSideBar={setOpenSideBar}
            setUsersSelected={setSelectedItems}
            openRightSideBarForMethod={handleRightSideBarMethod}
          />
        );
      case viewRightSideBarEnum.multipleUserActivation:
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectedItems.length === 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.singleShippingOrder);
    } else if (selectedItems.length > 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.multipleUserActivation);
    } else {
      setOpenSideBar(false);
    }
  }, [selectedItems]);

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled align="center">
                {Strings.manufacture.shippingOrder.title}
              </TitleStyled>
            </div>
            <div className="col-4 text-right">
              <Tooltip
                title={Strings.manufacture.shippingOrder.addShippingOrder}
                placement="top"
                arrow
                componentsProps={TooltipStyled}
              >
                <ButtonIconStyled
                  size="small"
                  onClick={() => redirectToAddShippingOrder()}
                >
                  <AddCircleOutlineIcon />
                </ButtonIconStyled>
              </Tooltip>
            </div>
          </div>
        </ContainerStyled>
      </Header>
      <ShipipngOrderTemplate
        isLoading={isLoading}
        isSuccess={isSuccess}
        allShippingOrder={data ?? []}
        openedSideBar={openSideBar}
        setOpenSideBar={setOpenSideBar}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
